import React from "react";
import ProviderOverview from "../kyb-common-components/provider-overview";

const Dnb = () => {
    return <ProviderOverview provider="dun_brad_street" />;
};

export default Dnb;
